import { render, staticRenderFns } from "./yuesao.vue?vue&type=template&id=d88652cc&scoped=true&lang=html&"
import script from "./yuesao.vue?vue&type=script&lang=js&"
export * from "./yuesao.vue?vue&type=script&lang=js&"
import style0 from "./yuesao.vue?vue&type=style&index=0&id=d88652cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88652cc",
  null
  
)

export default component.exports